import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import TablePaginationActions from "../../../../../../globals/components/TablePaginationActions";
import { CarrierTabEmptyRow, CarrierTabLoadingRow } from "./carrierTabTablePrimitives";

export default function CarrierStatesTabPanel({ vm }) {
  const {
    handleOpenStateDialog,
    rowsPerPageStates,
    handleDeleteState,
    loading,
    handleChangePageStates,
    handleChangeRowsPerPageStates,
    paginationSx,
    states,
    headerRowSx,
    pageStates,
    tableCardSx,
  } = vm;

  const renderBody = () => {
    if (loading) {
      return <CarrierTabLoadingRow colSpan={3} />;
    }
    if (states.length === 0) {
      return <CarrierTabEmptyRow colSpan={3} message="No states found." />;
    }
    const slice = states.slice(
      pageStates * rowsPerPageStates,
      pageStates * rowsPerPageStates + rowsPerPageStates,
    );
    return slice.map((state) => (
      <TableRow key={state.id}>
        <TableCell>{state.bond_state.state_name}</TableCell>
        <TableCell align="right">{state.bond_state.state_code}</TableCell>
        <TableCell align="center">
          <IconButton color="error" onClick={() => handleDeleteState(state.id)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenStateDialog}>
          Add State
        </Button>
      </Box>
      <TableContainer component={Paper} sx={tableCardSx}>
        <Table>
          <TableHead>
            <TableRow sx={headerRowSx}>
              <TableCell>State Name</TableCell>
              <TableCell align="right">State Code</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBody()}</TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        ActionsComponent={TablePaginationActions}
        component="div"
        count={states.length}
        page={pageStates}
        onPageChange={handleChangePageStates}
        rowsPerPage={rowsPerPageStates}
        onRowsPerPageChange={handleChangeRowsPerPageStates}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={paginationSx}
      />
    </>
  );
}

CarrierStatesTabPanel.propTypes = {
  vm: PropTypes.object.isRequired,
};
